import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const StyledIntro = styled.div`
  max-width: 90rem;
  margin: 0 auto;
  padding-top: 2rem;
  padding-bottom: ${props => (props.isEmpty ? "0" : "2rem")};

  ${props =>
    props.hasLine &&
    `
    position: relative;
    width:100%;
    max-width: 100%;
    text-align: center;

    &:after{
      position: absolute;
      bottom: 1rem;
      left:0;
      width: 100%;
      height: 0.1rem;
      background-color:#53565a;
      content:"";
      z-index:0;
    }

    h2{
      display: inline-block;
      position: relative;
      background: #fff;
      padding: 0 1rem;
      z-index: 3;
      margin: 0 auto;
    }
  `}

  @media (min-width: 769px) {
    padding-top: 4rem;
    padding-bottom: ${props => (props.isEmpty ? "2rem" : "4rem")};

    &:after {
      bottom: 2rem;
      height: 0.2rem;
    }

    h2 {
      padding: 0 2rem;
    }
  }
`

const StyledTitle = styled.h2`
  font-family: ${props => props.theme.crockpot.thirdFont};
  letter-spacing: -0.1rem;
  font-size: 1.8rem;
  color: ${props => props.theme.crockpot.text};
  font-weight: normal;
  text-align: center;
  margin: 0;

  @media (min-width: 769px) {
    font-size: 4rem;
  }

  i {
    display: inline-block;
    position: relative;
    top: -0.5rem;
    font-style: normal !important;
    font-size: 1rem;

    @media (min-width: 769px) {
      font-size: 1.2rem;
    }
  }

  p:last-child {
    margin-bottom: 0;
  }
`

const StyledDescription = styled.div`
  font-size: 1.3rem;
  line-height: 1.8rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 0;

  p {
    margin: 0;
  }

  @media (min-width: 769px) {
    font-size: 2.3rem;
    line-height: 2.8rem;
  }
`

const Intro = ({ title, description, extraClass, hasLine = false }) => {
  return (
    <StyledIntro isEmpty={!title && !description} hasLine={hasLine}>
      {title && <StyledTitle className={extraClass}>{title}</StyledTitle>}
      {description && description.length > 5 && (
        <StyledDescription>{description}</StyledDescription>
      )}
    </StyledIntro>
  )
}

Intro.propTypes = {
  extraClass: PropTypes.string,
  hasLine: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

export default Intro
